/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:10:17
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-08 10:20:04
 */
import { Radio, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../app/store";
import styles from "./MedicalData.module.css";
import { MedicalDataColumn } from "./columns";
import { getMedicalListAsync, selectMedicalList } from "./MedicalDataSlice";

export const MedicalData = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [time, setTime] = useState();

  const data = useSelector(selectMedicalList);

  useEffect(() => {
    dispatch(getMedicalListAsync({ scope: time }));
  }, [dispatch, time]);
  return (
    <div className={styles.main}>
      <Row
        style={{ height: "100px", width: "100%" }}
        align="middle"
        justify="space-between"
      >
        <h3 style={{ fontWeight: "bold" }}>浙江省监管数据总览</h3>
        <Radio.Group
          defaultValue={time}
          value={time}
          onChange={(e: any) => {
            setTime(e.target.value);
          }}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio.Button value={0}>近七天</Radio.Button>
          <Radio.Button value={1}>近30天</Radio.Button>
          <Radio.Button value={2}>近一年</Radio.Button>
          <Radio.Button>全部</Radio.Button>
        </Radio.Group>
      </Row>

      <div
        style={{ height: "calc(100% - 100px)" }}
        className={styles.MedicalData}
      >
        <Table
          rowKey={(record) => record.id}
          className={styles.MedicalTable}
          pagination={false}
          bordered
          onChange={(pagination, filters, sorter) => {
            console.log(sorter);
          }}
          style={{ height: "100%" }}
          dataSource={data}
          columns={MedicalDataColumn()}
        ></Table>
      </div>
    </div>
  );
};
